/**
 * GAP3-11 (#226): what Australians actually call their dogs.
 *
 * The breed lists are 391 American Kennel Club names. Australia is the primary market, and the
 * names an Australian owner types are frequently not on that list at all: Cavoodle is consistently
 * the country's most registered dog and does not appear, because the AKC name is Cavapoo. Groodle,
 * Spoodle and Moodle are the same story. Blue Heeler is the everyday name for a dog that IS on the
 * list, under Australian Cattle Dog. Every one of those owners hit a blank result at the exact
 * moment the tool was built to convert them.
 *
 * Staffy is worse than missing. The search is a substring match, so "staffy" finds "Staffy Bull
 * Bullmastiff" - a rare crossbreed - and never finds "Staffordshire Bull Terrier", because that
 * word is spelled "Staffordshire". A top-ten Australian breed resolved to the wrong dog.
 *
 * WHY A MAP AND NOT NEW BREED ENTRIES. Adding "Cavoodle" to the breed lists would put two names
 * for one dog in the dropdown, and they would drift apart the first time anyone edited one. The
 * query is expanded instead: the owner types what they say, the tool shows the name it holds.
 *
 * WHY ITS OWN FILE. Two tools need this and they share no code - the floating breed checker runs
 * on breed-modal.*, the size guide on size-guide.js against text rendered from Theme Editor
 * settings. One definition, loaded before both.
 *
 * EVERY TARGET BELOW EXISTS IN assets/breeds-by-size.json. An alias pointing at a name the lists
 * do not hold is worse than no alias: it turns a blank result into a broken one.
 */
(() => {
  window.WOOPF_BREED_ALIASES = {
    // The Australian -oodle family. Cavoodle alone outnumbers most pedigree breeds here.
    cavoodle: 'Cavapoo',
    groodle: 'Goldendoodle',
    spoodle: 'Cockapoo',
    moodle: 'Maltipoo',

    // Working dogs, by the names anyone outside a show ring uses.
    'blue heeler': 'Australian Cattle Dog',
    'red heeler': 'Australian Cattle Dog',
    heeler: 'Australian Cattle Dog',
    // No entry for koolie: the Australian Koolie was missing from the breed lists entirely
    // and was added to all three, so a plain search now reaches it and an alias would be
    // a second name for the same dog waiting to drift.

    // Staffy resolved to Staffy Bull Bullmastiff before this line existed.
    staffy: 'Staffordshire Bull Terrier',
    staffie: 'Staffordshire Bull Terrier',

    // Shortenings common enough to be the first thing typed.
    frenchie: 'French Bulldog',
    goldie: 'Golden Retriever',
    labby: 'Labrador Retriever',
    'sausage dog': 'Dachshund',
    'wiener dog': 'Dachshund',
    doxie: 'Dachshund',
    aussie: 'Australian Shepherd',
    rottie: 'Rottweiler',
    rotty: 'Rottweiler',
    dobie: 'Doberman Pinscher',
    alsatian: 'German Shepherd',
    gsd: 'German Shepherd',
    westie: 'West Highland White Terrier',
    yorkie: 'Yorkshire Terrier',
  };

  /**
   * The breed names a query should also look for. Whole words only: "aussiedoodle" must not drag
   * in the Australian Shepherd, and "labrastaff" must not drag in the Staffordshire Bull Terrier.
   *
   * Callers ADD these to their own matching rather than replacing the query with them. Replacing
   * would narrow a search that already worked - somebody typing "staffordshire" wants both
   * Staffordshire breeds, not whichever one a map happened to name.
   */
  window.WOOPF_BREED_ALIAS_TARGETS = (query) => {
    const q = String(query || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    if (!q) return [];

    const padded = ` ${q} `;
    const out = new Set();

    Object.keys(window.WOOPF_BREED_ALIASES).forEach((alias) => {
      if (padded.includes(` ${alias} `)) out.add(window.WOOPF_BREED_ALIASES[alias]);
    });

    return [...out];
  };
})();
